import { render, staticRenderFns } from "./customer-service-order-pickup.vue?vue&type=template&id=0b38a209"
import script from "./customer-service-order-pickup.vue?vue&type=script&lang=js"
export * from "./customer-service-order-pickup.vue?vue&type=script&lang=js"
import style0 from "./customer-service-order-pickup.vue?vue&type=style&index=0&id=0b38a209&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports